export default [
    {
        path: '/integration-itens',
        name: 'integration-itens',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Itens de Integração',
            icon: 'mdi-cog-transfer-outline',
        }
    }
]